module.exports = __webpack_public_path__ + "static/img/china.7e4086a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/china.svg
// module id = ajne
// module chunks = 1